import { gql } from '@apollo/client';

export const START_EMAIL_VERIFY = gql`
  mutation startEmailVerify($email: String!, $newsletter: Boolean) {
    startEmailVerify(email: $email, newsletter: $newsletter) {
      success
      message
    }
  }
`;

export const OTP_EMAIL_VERIFY = gql`
  mutation otpEmailVerify($otp: Int!) {
    otpEmailVerify(otp: $otp) {
      success
      message
    }
  }
`;

export const RESEND_EMAIL_VERIFY = gql`
  mutation resendEmailVerify {
    resendEmailVerify {
      success
      message
    }
  }
`;
